module.exports = __webpack_public_path__ + "img/product_11.681eec2.webp";